import React from 'react';
import Image from '../image';
import { Flex } from '../box';
import Text from '../text';
import { Weights } from '../title';
import { variants as titleVariants } from '../title/style';
import { variants, sizes } from './styles';

interface TipAlertProps {
  size?: keyof typeof sizes;
  variant?: keyof typeof variants;
  text?: React.ReactNode | string;
  weight?: Weights;
  textVariant?: keyof typeof titleVariants;
  'data-name'?: string;
  id?: string;
  alt?: string;
  alignItems?: 'center' | 'flex-start';
  alignImage?: 'center' | 'flex-start';
  gap?: 'sm' | 'xs';
}

const TipAlert = ({
  size = 'md',
  text,
  weight = 500,
  variant = 'lightbulb',
  textVariant = 'gray600',
  'data-name': dataName,
  alignItems = 'center',
  alignImage = 'flex-start',
  id,
  gap = 'sm',
  alt = '',
}: TipAlertProps) => (
  <Flex gap={gap} alignItems={alignItems}>
    <Image
      alt={alt}
      aria-hidden={!alt}
      width={sizes[size]?.image}
      src={variants[variant]?.image}
      alignSelf={alignImage}
    />
    <Text
      size={sizes[size].text}
      weight={weight}
      align={'left'}
      variant={textVariant}
      data-name={dataName}
      whiteSpace={'break-spaces'}
      id={id}
    >
      {text}
    </Text>
  </Flex>
);

export default TipAlert;
